// docs: https://github.com/altostra/type-validations#readme
import { enumOf, objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdSurveysResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      responses: maybe(number, true),
      channel: string,
      status: enumOf("active", "idle", "draft", "stopped", "archived", "published", "unpublished"),
      campaign_id: maybe(string, true),
      canvas_id: maybe(string, true),
      canvas_step_id: maybe(string, true),
      canvas_name: maybe(string, true),
      landing_page_id: maybe(string, true),
      last_edited: maybe(number, true),
    })
  ),
});
